/**
 * 🐋 Contact Page - Cetalingua FM
 */

import React, { useState } from 'react';
import './LegalPages.css';

const ContactPage = ({ onBack }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'general',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Implement actual form submission
    console.log('Contact form submitted:', formData);
    setSubmitted(true);
  };

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="back-btn" onClick={onBack}>← Back</button>
        
        <div className="legal-header">
          <span className="legal-logo">🐋</span>
          <h1>Contact Us</h1>
          <p className="legal-updated">We'd love to hear from you!</p>
        </div>

        <div className="legal-content">
          {/* Contact Cards */}
          <div className="contact-grid">
            <div className="contact-card">
              <div className="contact-icon">📧</div>
              <h3>General Inquiries</h3>
              <p>Questions about Cetalingua FM</p>
              <a href="mailto:hello@cetalingua.fm">hello@cetalingua.fm</a>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">📢</div>
              <h3>Advertiser Support</h3>
              <p>Help with your advertiser account</p>
              <a href="mailto:advertise@cetalingua.fm">advertise@cetalingua.fm</a>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">📡</div>
              <h3>Station Support</h3>
              <p>Help with station setup & uploads</p>
              <a href="mailto:stations@cetalingua.fm">stations@cetalingua.fm</a>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">🤝</div>
              <h3>Partnerships</h3>
              <p>Collaboration opportunities</p>
              <a href="mailto:partners@cetalingua.fm">partners@cetalingua.fm</a>
            </div>
          </div>

          {/* Contact Form */}
          {submitted ? (
            <div className="contact-form">
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <div style={{ fontSize: '64px', marginBottom: '16px' }}>✅</div>
                <h2 style={{ color: '#00DD66', marginBottom: '12px' }}>Message Sent!</h2>
                <p>Thank you for reaching out. We'll get back to you as soon as possible.</p>
                <button 
                  className="submit-btn" 
                  style={{ marginTop: '24px' }}
                  onClick={() => {
                    setSubmitted(false);
                    setFormData({ name: '', email: '', subject: 'general', message: '' });
                  }}
                >
                  Send Another Message
                </button>
              </div>
            </div>
          ) : (
            <div className="contact-form">
              <h2>Send Us a Message</h2>
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Your Name *</label>
                    <input 
                      type="text" 
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="John Doe"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input 
                      type="email" 
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="john@example.com"
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Subject *</label>
                  <select 
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="general">General Inquiry</option>
                    <option value="advertiser">Advertiser Support</option>
                    <option value="station">Station Support</option>
                    <option value="billing">Billing Question</option>
                    <option value="technical">Technical Issue</option>
                    <option value="partnership">Partnership Inquiry</option>
                    <option value="feedback">Feedback / Suggestion</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Message *</label>
                  <textarea 
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="How can we help you?"
                    required
                  />
                </div>

                <button type="submit" className="submit-btn">
                  Send Message →
                </button>
              </form>
            </div>
          )}

          {/* Additional Info */}
          <section style={{ marginTop: '40px' }}>
            <h2>Response Times</h2>
            <p>
              We aim to respond to all inquiries within 24-48 hours during business days. 
              For urgent technical issues, please include "URGENT" in your subject line.
            </p>
          </section>

          <section>
            <h2>Before You Contact Us</h2>
            <p>
              Many common questions are answered in our FAQ sections on the 
              <a href="#" onClick={(e) => e.preventDefault()}> Advertiser </a> 
              and 
              <a href="#" onClick={(e) => e.preventDefault()}> Station </a> 
              landing pages. Please check there first!
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
